import axios from "axios";
import { IAdHocProjectGroupResult, IAdHocProjectResult, IExportGroupProject } from "../models/applicationState";
import { toast, ToastContainer } from "react-toastify";

export interface IAdHocOcrV3Service {
    load(documentId: string): Promise<IAdHocProjectResult>;

    exportProjectLabelToSource(projectId: string, runGenerateModel: boolean);
    loadGroup(groupId: string): Promise<IAdHocProjectGroupResult>;
    exportGroupProjectLabelToSource(exportGroupProject: IExportGroupProject);
    // loadGroupDocument(groupId: string, documentId: string): Promise<IAdHocProjectResult | null>;
    loadGroupDocument(groupId: string);
    setGenerateModel(projectId: string, generateModel: boolean);
}

export default class AdHocOcrV3Service implements IAdHocOcrV3Service {
    public async loadGroup(groupId: string) {
        return new Promise<IAdHocProjectGroupResult>(async (resolve, reject) => {
            try {
                const project = await axios.get<IAdHocProjectGroupResult>(`${process.env.REACT_APP_HACHET_APIV3_URL}GetDocumentGroup/${groupId}`);
                if (project) {
                    resolve(project.data);
                }                
            }
            catch (ex) {
                if (axios.isAxiosError(ex)) {
                    // Extract error message from response if available
                    const errorMessage = ex.response?.data?.message || ex.response?.data || ex.message;
                    reject(errorMessage);
                } else {
                    reject(ex.message);
                }
            }
        })        
    }
    
    public async load(documentId: string) {
        return new Promise<IAdHocProjectResult>(async (resolve, reject) => {
            try {
                const project = await axios.get<IAdHocProjectResult>(`${process.env.REACT_APP_HACHET_APIV3_URL}GetDocument/${documentId}`);
                if (project) {
                    resolve(project.data);
                }                
            }
            catch (ex) {
                if (axios.isAxiosError(ex)) {
                    // Extract error message from response if available
                    const errorMessage = ex.response?.data?.message || ex.response?.data || ex.message;
                    reject(errorMessage);
                } else {
                    reject(ex.message);
                }
            }
        })        
    }

    // public async loadGroupDocument(groupId: string, documentId: string) {
    //     return new Promise<IAdHocProjectResult>(async (resolve, reject) => {
    //         try {
    //             const project = await axios.post<IAdHocProjectResult>(`${process.env.REACT_APP_HACHET_APIV3_URL}LLMProcessDocumentAsync`,
    //                 {
    //                     groupId: groupId,
    //                     documentId: documentId,
    //                     skipLLM: false
    //                 },
    //                 {
    //                     timeout: 180000 // 3 minutes in milliseconds
    //                 }
    //             );
    //             if (project) {
    //                 resolve(project.data);
    //             }                
    //         }
    //         catch (ex) {
    //             try {
    //                 const project = await axios.post<IAdHocProjectResult>(`${process.env.REACT_APP_HACHET_APIV3_URL}LLMProcessDocumentAsync`, 
    //                     {
    //                         groupId: groupId,
    //                         documentId: documentId,
    //                         skipLLM: true
    //                     }
    //                 );
    //                 if (project) {
    //                     resolve(project.data);
    //                 }                
    //             }
    //             catch (ex) {
    //                 if (axios.isAxiosError(ex)) {
    //                     // Extract error message from response if available
    //                     const errorMessage = ex.response?.data?.message || ex.response?.data || ex.message;
    //                     reject(errorMessage);
    //                 } else {
    //                     reject(ex.message);
    //                 }
    //             }
    //         }
    //     })        
    // }

    public async loadGroupDocument(groupId: string) {
        try {
            const result = await axios.post(
                `${process.env.REACT_APP_HACHET_APIV3_URL}LLMProcessDocumentsAsync`,
                {
                    groupId
                }
            );
            // Fire-and-forget (don’t await), but DO handle errors:
            // void axios
            //     .post(`${process.env.REACT_APP_HACHET_APIV3_URL}LLMProcessDocumentsAsync`, { groupId })
            //     .catch((err) => {
            //         console.error("LLMProcessDocumentsAsync failed", err);
            //     });
            console.log('loadGroupDocument success:', result);
        }
        catch (ex) {
            // Only retry if timeout
            console.log('loadGroupDocument error:', ex);
            // try {
            //     console.log('Retrying loadGroupDocument with skipLLM=true');
            //     const project = await axios.post<IAdHocProjectResult>(
            //         `${process.env.REACT_APP_HACHET_APIV3_URL}LLMProcessDocumentAsync`,
            //         {
            //             groupId,
            //             documentId,
            //             skipLLM: true
            //         }
            //     );

            //     return project.data;
            // }
            // catch (retryEx) {
            //     if (axios.isAxiosError(retryEx)) {
            //         throw retryEx.response?.data?.message || retryEx.response?.data || retryEx.message;
            //     }
            //     throw retryEx;
            // }
    
            // If not timeout, throw immediately
            // if (axios.isAxiosError(ex)) {
            //     throw ex.response?.data?.message || ex.response?.data || ex.message;
            // }
    
            throw ex;
        }
    }
    

    public async exportProjectLabelToSource(projectId: string, runGenerateModel: boolean) {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await axios.post(`${process.env.REACT_APP_HACHET_APIV3_URL}ExportDocument`, 
                    {
                        requestId: projectId,
                        generateModel: runGenerateModel
                    });
                if (result && result.data && result.data.successful) {
                    const postUrl = result.data.postUrl;
                    if (postUrl) {
                        let isRedirect = !!result.data.isRedirect;
                        this.postToUrl(postUrl, result.data.authorizationHeader, result.data.base64Content, isRedirect);
                        resolve(true);
                    }
                }        
                else {
                    reject(result.data.content);
                }        
            }
            catch(ex) {
                reject(ex);
            }
        })
    }

    public async exportGroupProjectLabelToSource(exportGroupProject: IExportGroupProject) {
        try {
            const result = await axios.post(
                `${process.env.REACT_APP_HACHET_APIV3_URL}ExportDocumentGroup`,
                exportGroupProject,                
                {
                    withCredentials: true, // Include credentials (e.g., cookies)
                }
            );
    
            if (result && result.data && result.data.successful) {
                const postUrl = result.data.postUrl;
    
                if (postUrl) {
                    await this.postToUrlGroup(
                        postUrl,
                        result.data.authorizationHeader,
                        result.data.base64Content,
                        false
                    );
    
                    const docIds = exportGroupProject.exportDocuments.map(r => r.requestId);
    
                    await axios.post(
                        `${process.env.REACT_APP_HACHET_APIV3_URL}UpdateDocumentsToPosted`,
                        { documentIds: docIds }
                    );
    
                    return true; // ← was resolve(true)
                }
            } else {
                throw result.data.content; // ← was reject(result.data.content)
            }
        } catch (ex) {  // ← remove ": any" here
            if (ex && (ex as any).response && (ex as any).response.status) {
                const errorCode = (ex as any).response.status;
    
                // Show user-friendly messages based on the error code
                switch (errorCode) {
                    case 400:
                        toast.error("Bad Request: Please check the data and try again.");
                        break;
                    case 401:
                        toast.error("Unauthorized: Please log in and try again.");
                        break;
                    case 403:
                        toast.error("Forbidden: You do not have permission to perform this action.");
                        break;
                    case 404:
                        toast.error("Not Found: The requested resource could not be found.");
                        break;
                    case 500:
                        toast.error("Server Error: Something went wrong on our end. Please try again later.");
                        break;
                    default:
                        toast.error("An unexpected error occurred. Please try again.");
                        break;
                }
            } else {
                toast.error("Network Error: Please check your internet connection and try again.");
            }
    
            throw ex; // ← was reject(ex)
        }
    }
    

    // public async exportGroupProjectLabelToSource(exportGroupProject: IExportGroupProject) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const result = await axios.post(`${process.env.REACT_APP_HACHET_APIV3_URL}ExportDocumentGroup`, exportGroupProject);
    //             if (result && result.data && result.data.successful) {
    //                 const postUrl = result.data.postUrl;
    //                 if (postUrl) {                        
    //                     await this.postToUrlGroup(postUrl, result.data.authorizationHeader, result.data.base64Content, false);
    //                     const docIds = exportGroupProject.exportDocuments.map(r => r.requestId);
    //                     await axios.post(`${process.env.REACT_APP_HACHET_APIV3_URL}UpdateDocumentsToPosted`, 
    //                         {
    //                             documentIds: docIds
    //                         });
    //                     resolve(true);
    //                 }
    //             }        
    //             else {
    //                 reject(result.data.content);
    //             }        
    //         }
    //         catch(ex) {
    //             if (ex.response && ex.response.status) {
    //                 const errorCode = ex.response.status;
    
    //                 // Show user-friendly messages based on the error code
    //                 switch (errorCode) {
    //                     case 400:
    //                         toast.error("Bad Request: Please check the data and try again.");
    //                         break;
    //                     case 401:
    //                         toast.error("Unauthorized: Please log in and try again.");
    //                         break;
    //                     case 403:
    //                         toast.error("Forbidden: You do not have permission to perform this action.");
    //                         break;
    //                     case 404:
    //                         toast.error("Not Found: The requested resource could not be found.");
    //                         break;
    //                     case 500:
    //                         toast.error("Server Error: Something went wrong on our end. Please try again later.");
    //                         break;
    //                     default:
    //                         toast.error("An unexpected error occurred. Please try again.");
    //                         break;
    //                 }
    //             } else {
    //                 // Handle cases where the error does not have a response (e.g., network issues)
    //                 toast.error("Network Error: Please check your internet connection and try again.");
    //             }
    //             reject(ex);
    //         }
    //     })
    // }

    public async setGenerateModel(projectId: string, generateModel: boolean) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${process.env.REACT_APP_HACHET_APIV3_URL}SetGenerateModel`, 
                    {
                        projectId,
                        generateModel
                    });
                resolve(true);
            }
            catch(ex) {
                reject(ex);
            }
        })
    }

    private base64ToArrayBuffer(base64) {
        var binaryString = atob(base64);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    private postToUrl(url, token, stringArr, reRoute = true): Promise<void> {
        return new Promise((resolve, reject) => {
            const base64String = btoa(stringArr);
            const byteArrFromStr = this.base64ToArrayBuffer(stringArr);
    
            axios
                .post(url, byteArrFromStr, {
                    withCredentials: false,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                    },
                })
                .then((response) => {
                    if (response.data && reRoute) {
                        window.location.href = response.data;
                        resolve(); // Resolve the promise if re-routing is successful
                    } else {
                        // Open the response URL in a new browser window positioned on the right half of the screen
                        const screenWidth = window.screen.width; // Total screen width
                        const screenHeight = window.screen.height; // Total screen height
                        const popupWidth = screenWidth / 2; // Half the screen width
                        const popupHeight = screenHeight; // Full screen height
                        const popupLeft = screenWidth / 2; // Start at the middle of the screen
                        const popupTop = 0; // Start at the top of the screen
    
                        const popup = window.open(
                            response.data, // URL to open
                            "_blank", // Open in a new tab or window
                            `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},scrollbars=yes,resizable=yes`
                        );
    
                        // Check if the pop-up was blocked
                        if (!popup || popup.closed || typeof popup.closed === "undefined") {
                            alert("Pop-up blocked! Please allow pop-ups for this site.");
                            //reject(new Error("Pop-up blocked by the browser.")); // Reject if the pop-up is blocked
                        } else {
                            resolve(); // Resolve the promise if the pop-up opens successfully
                        }
                    }
                })
                .catch((error) => {
                    console.error("Error in postToUrl:", error);
                    reject(error); // Reject the promise with the error
                    toast.error('An error occured posting to source.');
                });
        });
    }

    // private postToUrl(url, token, stringArr, reRoute = true) {
    //     var base64String = btoa(stringArr);
    //     var byteArrFromStr = this.base64ToArrayBuffer(stringArr);
    //     axios.post(url, byteArrFromStr, {
    //         withCredentials: false,
    //         headers: {
    //             'Content-Type': 'application/json', 
    //             'Authorization': token
    //         }
    //         }).then(response => {
    //             if (response.data && reRoute) {                    
    //                 window.location.href = response.data;
    //             }                
    //             else {
    //                 // Open the response URL in a new browser window positioned on the right half of the screen
    //                 const screenWidth = window.screen.width; // Total screen width
    //                 const screenHeight = window.screen.height; // Total screen height
    //                 const popupWidth = screenWidth / 2; // Half the screen width
    //                 const popupHeight = screenHeight; // Full screen height
    //                 const popupLeft = screenWidth / 2; // Start at the middle of the screen
    //                 const popupTop = 0; // Start at the top of the screen

    //                 const popup = window.open(
    //                     response.data, // URL to open
    //                     "_blank", // Open in a new tab or window
    //                     `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},scrollbars=yes,resizable=yes`
    //                 );

    //                 // Check if the pop-up was blocked
    //                 if (!popup || popup.closed || typeof popup.closed === "undefined") {
    //                     alert("Pop-up blocked! Please allow pop-ups for this site.");
    //                 }
    //             }
    //         }).catch(error => {
    //             throw error;
    //         });
        
    // }

    // private postToUrlGroup(url, token, stringArr, reRoute = true) {
    //     var base64String = btoa(stringArr);
    //     var byteArrFromStr = this.base64ToArrayBuffer(stringArr);
    //     axios.post(url, byteArrFromStr, {
    //         withCredentials: false,
    //         headers: {
    //             'Content-Type': 'application/json', 
    //             'Authorization': token
    //         }
    //         }).then(response => {
                
    //         }).catch(error => {
    //             console.error(error);
    //             toast.error('An error occured posting to source.');
    //         });
        
    // }

    // private async postToUrlGroup(url: string, token: string, stringArr: string, reRoute = true): Promise<void> {
    //     try {
    //         const base64String = btoa(stringArr); // Convert string to base64
    //         const byteArrFromStr = this.base64ToArrayBuffer(stringArr); // Convert base64 to ArrayBuffer
    
    //         await axios.post(url, byteArrFromStr, {
    //             withCredentials: false,
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: token,
    //             },
    //         });
    //     } catch (error) {
    //         toast.error("An error occurred while posting to the source.");
            
    //     }
    // }

    private async postToUrlGroup(url: string, token: string, stringArr: string, reRoute = true): Promise<void> {
        
            try {
                const base64String = btoa(stringArr); // Convert string to base64
                const byteArrFromStr = this.base64ToArrayBuffer(stringArr); // Convert base64 to ArrayBuffer
    
                const response = await axios.post(url, byteArrFromStr, {
                    withCredentials: false,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                    },
                });

                //Comment this during development
                //resolve();
    
                //Uncomment this during development
                // if (response.data) {
                //     // Redirect to the response URL
                //     window.location.href = response.data;
                //     resolve(); // Resolve the promise if re-routing is successful
                // } 

                //else {
                //     // Open the response URL in a new browser window positioned on the right half of the screen
                //     const screenWidth = window.screen.width; // Total screen width
                //     const screenHeight = window.screen.height; // Total screen height
                //     const popupWidth = screenWidth / 2; // Half the screen width
                //     const popupHeight = screenHeight; // Full screen height
                //     const popupLeft = screenWidth / 2; // Start at the middle of the screen
                //     const popupTop = 0; // Start at the top of the screen
    
                //     const popup = window.open(
                //         response.data, // URL to open
                //         "_blank", // Open in a new tab or window
                //         `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},scrollbars=yes,resizable=yes`
                //     );
    
                //     // Check if the pop-up was blocked
                //     if (!popup || popup.closed || typeof popup.closed === "undefined") {
                //         reject(new Error("Pop-up blocked by the browser.")); // Reject if the pop-up is blocked
                //     } else {
                //         resolve(); // Resolve the promise if the pop-up opens successfully
                //     }
                // }
            } catch (error) {
                console.error("Error in postToUrlGroup:", error);
                throw error;
                //reject(error); // Reject the promise with the error
            }
    }
}
